/** Общие настройки: время, типы мероприятий, размеры списков, организация. */

import type { ReactNode } from 'react';

import { Field, Select, TextInput } from '../../components/ui.tsx';
import { Section, type SettingsTabProps } from './shared.tsx';

/** Часовые пояса, которые реально встречаются у русскоязычных сообществ. */
const TIMEZONES = [
  'Europe/Kaliningrad',
  'Europe/Moscow',
  'Europe/Samara',
  'Asia/Yekaterinburg',
  'Asia/Omsk',
  'Asia/Krasnoyarsk',
  'Asia/Irkutsk',
  'Asia/Yakutsk',
  'Asia/Vladivostok',
  'Europe/Kyiv',
  'Europe/Minsk',
  'Asia/Almaty',
  'UTC',
];

export function GeneralTab({ draft, update }: SettingsTabProps): ReactNode {
  return (
    <>
      <Section title="Время и мероприятия">
        <Field label="Часовой пояс" hint="В нём вводится и показывается время наборов">
          <Select
            value={draft.timezone}
            onChange={(event) => {
              update('timezone', event.target.value);
            }}
          >
            {(TIMEZONES.includes(draft.timezone) ? TIMEZONES : [draft.timezone, ...TIMEZONES]).map((zone) => (
              <option key={zone} value={zone}>
                {zone}
              </option>
            ))}
          </Select>
        </Field>

        <Field label="Типы мероприятий" hint="Через запятую. Именно из них выбирают при создании набора">
          <TextInput
            value={draft.eventTypes.join(', ')}
            onChange={(event) => {
              update(
                'eventTypes',
                event.target.value
                  .split(',')
                  .map((type) => type.trim())
                  .filter((type) => type !== ''),
              );
            }}
          />
        </Field>

        <div className="grid gap-4 sm:grid-cols-2">
          <Field label="Размер состава по умолчанию">
            <TextInput
              type="number"
              min={1}
              max={100}
              value={draft.defaultCapacity}
              onChange={(event) => {
                update('defaultCapacity', Number.parseInt(event.target.value, 10) || 1);
              }}
            />
          </Field>

          <Field label="Строк участников в сообщении" hint="Сколько человек показывать в посте Discord">
            <TextInput
              type="number"
              min={1}
              max={500}
              value={draft.maxVisibleRows}
              onChange={(event) => {
                update('maxVisibleRows', Number.parseInt(event.target.value, 10) || 1);
              }}
            />
          </Field>
        </div>
      </Section>

      <Section
        title="Игровая служба"
        description="Откуда берутся боевые показатели каптов в карточке игрока."
      >
        {/* Номер организации бот определяет сам по составу первого же
            капта. Поле нужно, чтобы поправить или сбросить: за союзников
            иногда играет столько наших, что счёт вводит в заблуждение. */}
        <Field
          label="Организация в Majestic"
          hint={
            draft.combatFamilyId === null
              ? 'Пусто — бот определит по составу ближайшего капта'
              : `${draft.combatFamilyName ?? 'без названия'} — очистите, чтобы определить заново`
          }
        >
          <TextInput
            type="number"
            min={1}
            value={draft.combatFamilyId ?? ''}
            onChange={(event) => {
              const value = Number.parseInt(event.target.value, 10);
              update('combatFamilyId', Number.isInteger(value) && value > 0 ? value : null);
            }}
          />
        </Field>
      </Section>
    </>
  );
}
